export function readable_question(input) {
  const chunks = input.split("--");
  return "Q" + (Math.round(chunks[1]) + 1);
}
